const Icons = [
  'facebook-square',
  'instagram',
  'snapchat-square',
  'twitter',
  'youtube',
  'frown-l',
  'frown-open-l',
  'laugh-l',
  'meh-blank-l',
  'meh-l',
  'smile-l',
  'angle-double-left',
  'angle-double-right',
  'angle-left',
  'angle-right',
  'bars-r',
  'bookmark-r',
  'check-circle-r',
  'check-r',
  'clock-r',
  'code-r',
  'copy-r',
  'exclamation-circle-r',
  'exclamation-triangle-r',
  'grip-v-r',
  'image-r',
  'inbox',
  'info-circle-r',
  'lightbulb-r',
  'lock-r',
  'plus-r',
  'sync-r',
  'times-r',
  'arrow-alt-down',
  'arrow-alt-from-bottom',
  'arrow-alt-up',
  'arrow-left',
  'asterisk',
  'bars',
  'bell',
  'book',
  'bookmark',
  'briefcase-medical',
  'briefcase',
  'building',
  'bullhorn',
  'bus',
  'calculator',
  'calendar-alt',
  'calendar-check',
  'caret-down',
  'chart-area',
  'chart-line',
  'check-circle',
  'check',
  'chess',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'clipboard-list',
  'clock',
  'cog',
  'dollar-sign',
  'ellipsis-h',
  'ellipsis-v',
  'envelope',
  'external-link-alt',
  'eye-slash',
  'eye',
  'file-alt',
  'flag',
  'folder-open',
  'frown-open',
  'frown',
  'gift',
  'globe',
  'graduation-cap',
  'hand-holding-heart',
  'heart',
  'home-heart',
  'home',
  'id-card',
  'info-circle',
  'laugh',
  'lightbulb',
  'list',
  'lock-alt',
  'lock-open-alt',
  'map-marker-alt',
  'map-signs',
  'meh-blank',
  'meh',
  'minus-circle',
  'minus',
  'mobile-alt',
  'money-bill-alt',
  'money-bill',
  'palette',
  'pen',
  'pencil',
  'piggy-bank',
  'plus-circle',
  'quote-left',
  'redo-alt',
  'school',
  'search',
  'sliders-h',
  'smile',
  'sort-down',
  'sort-up',
  'sort',
  'spinner',
  'star',
  'tag',
  'thumbs-down',
  'thumbs-up',
  'times-circle',
  'trash',
  'trophy',
  'university',
  'user-circle',
  'user',
  'users',
  'video',
];

export default Icons;

export type RaiseMeIcon = (typeof Icons)[number];
